import { render } from "./SurveyPage05.vue?vue&type=template&id=47209b3a&scoped=true"
const script = {}

import "./SurveyPage05.vue?vue&type=style&index=0&id=47209b3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47209b3a"]])

export default __exports__